// Minimal markdown renderer: **bold**, bullet lines, and line breaks. No deps.
export function MarkdownLite({ text, className = "" }) {
  if (!text) return null;
  const renderInline = (s) =>
    s.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
      part.startsWith("**") && part.endsWith("**")
        ? <strong key={i} className="text-white font-semibold">{part.slice(2, -2)}</strong>
        : <span key={i}>{part}</span>
    );
  const lines = text.split("\n").filter((l) => l.trim() !== "");
  return (
    <div className={`space-y-1.5 ${className}`}>
      {lines.map((line, i) => {
        const t = line.trim();
        if (/^[-*•]\s+/.test(t)) {
          return (
            <div key={i} className="flex gap-2">
              <span className="text-[#F2B705] mt-0.5">•</span>
              <span className="flex-1">{renderInline(t.replace(/^[-*•]\s+/, ""))}</span>
            </div>
          );
        }
        return <p key={i}>{renderInline(t)}</p>;
      })}
    </div>
  );
}
